<template>
    <div>
        <ui-slider
            dark
            arrows-on-top
            mobile-auto
            scrollbar
            is-overfade
            @visible="visibleSlides = $event"
        >
            <template v-slot:prepend>
                <h3 class="h2-h3m white-text _mb-8">
                    Кешбэк по премиальной карте
                </h3>
                <p class="p2 white-text">
                    C 1 апреля 2025 года. <br class="_desktop-hidden">
                    Максимальная сумма выплаты 10&nbsp;тыс.&nbsp;₽/&#x2060;мес.
                </p>
            </template>
            <template
                v-for="(slide, i) in slides"
                v-slot:[`slide-${slide.id}`]
            >
                <div
                    :key="slide.id"
                >
                    <div
                        class="premium-cashback-slider__slide"
                        @click="onClickSlide(slide.id)"
                    >
                        <div
                            class="premium-cashback-slider__slide-pic"
                            :class="{
                                'premium-cashback-slider__slide-pic_active': slide.id === activeSlide,
                            }"
                        >
                            <div
                                class="premium-cashback-slider__slide-pic-img"
                                :style="{
                                    'background-image': getSlideBackground(i, slide.image),
                                }"
                            />
                        </div>
                        <div
                            v-if="slide.label"
                            class="premium-cashback-slider__slide-labels"
                        >
                            <div
                                v-if="slide.label==='new'"
                                class="_dflex"
                            >
                                <span class="_dinlblock ico ico-ahead-fill ico_color_green-premium ico_size_16 _mr-4" />
                                <span class="p2 premium-common__text_green">Новое</span>
                            </div>
                        </div>
                        <div class="premium-cashback-slider__slide-info">
                            <div class="factoid _mb-8 text-align-center white-text" v-html="slide.title"></div>
                            <div class="p2 text-align-center white-text" v-html="slide.subtitle"></div>
                        </div>
                    </div>
                </div>
            </template>
        </ui-slider>
        <premium-modal
            v-model="isOpenModal"
            fullscreen
            close-class-list="premium-cashback-slider__close"
        >
            <premium-stories-slider
                v-model="activeSlide"
                :items="infoSlides"
                v-predlogi
            >
                <template #slide-leftInfo>
                    <div class="_dflex _min-h_full _w-280 _flexdir-column _justify-content-center" v-predlogi>
                        <div class="h1 _mb-16">
                            <span class="premium-common__text_green">Выгода</span>
                            <br>
                            <span class="white-text"> в рублях</span>
                        </div>
                        <div class="h3 white-text _mb-8">
                            5%
                        </div>
                        <p class="p1 white-text _mb-8">
                            Кешбэк в рублях на покупки в специальных категориях и 1% за остальные покупки (до 10&nbsp;тыс.&nbsp;₽/&#x2060;мес.)
                        </p>
                        <div class="h3 premium-common__text_green _mb-8">+</div>
                        <div class="h3 white-text _mb-8">
                            до 30%
                        </div>
                        <p class="p1 white-text">
                            На покупки от платежной системы «МИР»
                        </p>
                    </div>
                </template>
                <template #slide-back-0>
                    <div class="_mr-24-24 _ml-24 _pt-32-80 _h-full" v-predlogi>
                       <div class="h4 _mb-8 white-text">Кешбэк не выплачивается по МСС кодам:</div>
                       <ul class="p2 _mb-16 white-text">
                            <li>- Выдача наличных: МСС 6010, 6011</li>
                            <li>- Квази-кэш-операции: MCC 6529, 6530, 7995, 5094, 6211, 9754, 9223, 6050, 6051</li>
                            <li>- Услуги страховых и инвестиционных компаний: МСС 6300, 5960</li>
                            <li>- Операции в пользу ломбардов: МСС 5933</li>
                            <li>- Оплата государственных услуг: МСС 9399, 9222, 9211, 9223, 9311</li>
                            <li>- Коммунальные услуги и оплата связи: МСС 4900, 4814</li>
                            <li>- Перевод денежных средств: МСС 6012, 6532-6538, 4829, 6540</li>
                            <li>- Оплата товаров и услуг в ТСП: MCC 5999, 8999, 7399</li>
                            <li>- Пополнение счетов для эскроу, агенты недвижимости и менеджеры</li>
                            <li>- Аренда: МСС 6513 (исключение: оплата аренды в домах от ДОМ.РФ)</li>
                       </ul>
                       <p class="p2 white-text">
                            Подробная информация размещена в Программе лояльности для физических лиц – клиентов АО «Банк ДОМ.РФ».
                       </p>
                    </div>
                </template>
                <template #slide-back-1>
                    <div class="_h-full _pb-24 _pt-32-80">
                        <div class="_mr-12 _pr-12 _ml-24  _h-full _overflow-auto _scrollbar _scrollbar_green-premium" v-predlogi>
                            <div class="h4 _mb-8 white-text">Кешбэк выплачивается по МСС кодам:</div>
                            <p class="p2 white-text">
                                МСС 3000, 3001, 3002, 3003, 3004, 3005, 3006, 3007, 3008, 3009, 3010, 3011, 3012, 3013, 3014, 3015, 3016, 3017, 3018, 3019, 3020, 3021, 3022, 3023, 3024, 3025, 3026, 3027, 3028, 3029, 3030, 3031, 3032, 3033, 3034, 3035, 3036, 3037, 3038, 3039, 3040, 3041, 3042, 3043, 3044, 3045, 3046, 3047, 3048, 3049, 3050, 3051, 3052, 3053, 3054, 3055, 3056, 3057, 3058, 3059, 3060, 3061, 3062, 3063, 3064, 3065, 3066, 3067, 3068, 3069, 3070, 3071, 3072, 3073, 3074, 3075, 3076, 3077, 3078, 3079, 3080, 3081, 3082, 3083, 3084, 3085, 3086, 3087, 3088, 3089, 3090, 3091, 3092, 3093, 3094, 3095, 3096, 3097, 3098, 3099, 3100, 3101, 3102, 3103, 3104, 3105, 3106, 3107, 3108, 3109, 3110, 3111, 3112, 3113, 3114, 3115, 3116, 3117, 3118, 3119, 3120, 3121, 3122, 3123, 3124, 3125, 3126, 3127, 3128, 3129, 3130, 3131, 3132, 3133, 3134, 3135, 3136, 3137, 3138, 3139, 3140, 3141, 3142, 3143, 3144, 3145, 3146, 3147, 3148, 3149, 3150, 3151, 3152, 3153, 3154, 3155, 3156, 3157, 3158, 3159, 3160, 3161, 3162, 3163, 3164, 3165, 3166, 3167, 3168, 3169, 3170, 3171, 3172, 3173, 3174, 3175, 3176, 3177, 3178, 3179, 3180, 3181, 3182, 3183, 3184, 3185, 3186, 3187, 3188, 3189, 3190, 3191, 3192, 3193, 3194, 3195, 3196, 3197, 3198, 3199, 3200, 3201, 3202, 3203, 3204, 3205, 3206, 3207, 3208, 3209, 3210, 3211, 3212, 3213, 3214, 3215, 3216, 3217, 3218, 3219, 3220, 3221, 3222, 3223, 3224, 3225, 3226, 3227, 3228, 3229, 3230, 3231, 3232, 3233, 3234, 3235, 3236, 3237, 3238, 3239, 3240, 3241, 3242, 3243, 3244, 3245, 3246, 3247, 3248, 3249, 3250, 3251, 3252, 3253, 3254, 3255, 3256, 3257, 3258, 3259, 3260, 3261, 3262, 3263, 3264, 3265, 3266, 3267, 3268, 3269, 3270, 3271, 3272, 3273, 3274, 3275, 3276, 3277, 3278, 3279, 3280, 3281, 3282, 3283, 3284, 3285, 3286, 3287, 3288, 3289, 3290, 3291, 3292, 3293, 3294, 3295, 3296, 3297, 3298, 3299, 3300, 3301, 4511, 4582
                            </p>
                        </div>
                    </div>
                </template>
            </premium-stories-slider>
        </premium-modal>
    </div>
</template>
<script>
import PremiumModal from './PremiumModal.vue';
import PremiumStoriesSlider from './PremiumStoriesSlider.vue';
import { useStore } from '../../store';
import { computed } from 'vue';

export default {
    name: 'PremiumCashbackSlider',
    components: {
        PremiumModal,
        PremiumStoriesSlider,
    },
    setup() {
        const store = useStore();

        const isMobile = computed(() => store.state.app.isMobile);

        return {
            isMobile,
        };
    },
    data() {
        return {
            slides: [
                /*{
                    id: '7',
                    title: '7% ',
                    subtitle: 'Гастрономический театр',
                    image: 'cashback-svet',
                    info: {
                        title: '7% - кешбэк за покупки в гастрономическом театре SVET',
                        subtitle: 'Оплачивайте покупки в SVET и получайте 7% от платежной системы «Мир». Перед оплатой зарегистрируйте вашу карту Mir Supreme на сайте или в приложении «Привет!)». Максимальный кешбэк\u00a0-\u00a05\u00a0000\u00a0₽ в месяц. Предложение действует до 31.12.2024.',
                        image: 'cashback-info-svet',
                    },
                },*/
                {
                    id: '4',
                    title: '12%',
                    subtitle: 'Кафе и рестораны ',
                    image: 'cashback-restaurants',
                    info: {
                        title: 'До 12% кешбэк за оплату в ресторанах',
                        subtitle: 'Получайте 5% кешбэка от банка за оплату картой Mir Supreme в кафе и ресторанах. Ещё 7% кешбэка вам начислит платежная система «Мир» за посещение ресторанов авторской кухни. Предложение действует до 31.12.2025 для WRF, Lucky Group, Novikov Group, Pinskiy&Co, DUO Band, Ginza Project (Санкт-Петербург), Рестораны Арама Мнацаканова, BURO Group.',
                        image: 'cashback-info-eat',
                        mcc: 'МСС 5811, 5812, 5813',
                    },
                },
                {
                    id: '6',
                    title: '10% ',
                    subtitle: 'Яндекс Go',
                    image: 'cashback-taxi1',
                    info: {
                        title: 'Кешбэк 10% за первые 3 поездки в Ultima от Яндекс Go',
                        subtitle: 'Оплачивайте поездки в классах Ultima на сайте или в приложении Яндекс Go картой Mir Supreme и получайте кешбэк 10% за первые 3 поездки каждый месяц от платежной системы «Мир». Максимальная сумма кешбэка- 500 ₽ за поездку. Предложение действует до 31.12.2025',
                        image: 'cashback-info-taxi',
                    },
                },
                {
                    id: '7',
                    title: '5% ',
                    subtitle: 'Яндекс Афиша',
                    image: 'cashback-tickets',
                    info: {
                        title: 'Кешбэк 5% за оплату билетов в Яндекс Афише',
                        subtitle: 'Оплачивайте билеты на мероприятия картой Mir Supreme на сайте vamprivet.ru в разделе «Яндекс Афиша» и получайте кешбэк 5% от платежной системы «Мир». Предложение действует до 30.06.2025',
                        image: 'cashback-info-tickets',
                    },
                },
                /*{
                    id: '3',
                    title: '5% ',
                    subtitle: 'Ювелирные украшения',
                    image: 'cashback-jewelry',
                    info: {
                        title: '5% кешбэк на ювелирные украшения',
                        subtitle: 'Приятная выгода от покупки ювелирных украшений и часов',
                        image: 'cashback-info-jewelry',
                        mcc: 'МСС 5944',
                    },
                },*/
                {
                    id: '3',
                    title: '5% ',
                    subtitle: 'Авиабилеты',
                    image: 'cashback-avia',
                    info: {
                        title: '5% кешбэк на авиабилеты',
                        subtitle: 'Взлетайте выше, а мы позаботимся о вашей выгоде',
                        image: 'cashback-info-avia',
                        mcc: 'МСС 3000-3069, 3071-3072, 3075-3079, 3081-3089, 3090, 3092, 3094-3100, 3102-3103, 3106, 3110-3112, 3115, 3117-3118, 3125-3127, 3129-3133, 3135-3138, 3143-3146, 3148, 3151, 3154, 3156, 3159, 3161, 3164-3165, 3167, 3170-3172, 3174-3178, 3180-3188, 3190-3193, 3196-3197, 3200, 3203-3204, 3206, 3211-3213, 3215-3223, 3226, 3228-3229, 3231, 3233-3236, 3238-3243, 3245-3248, 3251-3254, 3256, 3259-3263, 3266-3267, 3280, 3282, 3284-3287, 3292-3299, 3300-3301, 4511',
                    },
                },
                {
                    id: '2',
                    title: '5% ',
                    subtitle: 'Развлечения',
                    image: 'cashback-entertainment',
                    info: {
                        title: '5% кешбэк на развлечения',
                        subtitle: 'Провести вечер  в театре, покататься на аттракционах  или посмотреть новинки в кино',
                        image: 'cashback-info-entertainment',
                        mcc: 'МСС 5733, 5735, 5815, 5816, 5817, 5818, 5949, 5998, 7032, 7221, 7395, 7829, 7832, 7833, 7841, 7911, 7922, 7929, 7932, 7933, 7941, 7991, 7992, 7993, 7994, 7996, 7997, 7998, 7999, 8664',
                    },
                },
                /*{
                    id: '1',
                    title: '5%',
                    subtitle: 'Красота',
                    image: 'cashback-1',
                    info: {
                        title: '5% кешбэк на красоту',
                        subtitle: 'Посещайте салоны красоты, спа и клубы здоровья вместе с банком ДОМ.РФ',
                        image: 'cashback-info-beauty',
                        mcc: 'МСС 7230, 7297, 7298',
                    },
                },*/
                {
                    id: '5',
                    title: '5% ',
                    subtitle: 'Аренда',
                    image: 'arenda-5',
                    info: {
                        title: '5% кешбэк на аренду в домах от ДОМ.РФ',
                        subtitle: 'Кешбэк выплачивается при внесении платы по договору аренды, а также за оплату коммунальных услуг через личный кабинет на сайте <a href="https://аренда.дом.рф/promo/vernyem-5-procentov-za-arendu-kvartiry/" target="_blank" rel="nofollow" class="link">аренда.дом.рф</a> или в мобильном приложении, указанном в договоре аренды',
                        image: 'cashback-info-arenda',
                        mcc: 'МСС 6513',
                    },
                },
                {
                    id: '0',
                    title: '1% ',
                    subtitle: 'За остальные покупки',
                    image: 'cashback-0',
                    info: {
                        title: '1% за остальные покупки',
                        subtitle: 'Любые покупки по вашей карте будут выгодными',
                        image: 'cashback-info-all',
                        hasBack: true,
                    },
                },
            ],
            leftInfoSlide: {
                id: 'leftInfo',
                transparent: true,
                noZoom: true,
            },
            activeSlide: 'leftInfo',
            visibleSlides: [],
            isOpenModal: false,
        };
    },
    computed: {
        infoSlides() {
            let slides = [...this.slides.map((item) => ({
                id: item.id,
                ...item.info,
            }))];
            if (!this.isMobile) {
                slides = [this.leftInfoSlide, ...slides];
            }
            return slides;
        },
    },
    methods: {
        onClickSlide(id) {
            this.activeSlide = id;
            this.isOpenModal = true;
        },
        getSlideBackground(i, image) {
            const bg = `url(/local/templates/redesign/src/assets/img/premium/premium-cashback-slider/${image}.webp)`;
            return this.visibleSlides.includes(i) ? bg : 'unset';
        },
    },
};
</script>
<style lang="scss">
@import '../../assets/scss/base/variables';
@import '../../assets/scss/base/functions';
@import '../../assets/scss/base/mixins';

.premium-cashback-slider {
    &__slide {
        user-select: none;
        position: relative;
        @include fluid('width', 233px, 119px);
        @include fluid('margin-right', 32px, 16px);
    }

    &__slide-pic {
        position: relative;
        width: 100%;
        @include fluid('height', 249px, 123px);
        @include fluid('--premium-c-s--img-w', 219px, 109px);
        @include fluid('--premium-c-s--img-h', 235px, 116px);
        cursor: pointer;
        background: center / contain no-repeat url('/local/templates/redesign/src/assets/img/premium/premium-cashback-slider/cashback-frame.webp');
    }

    &__slide-pic-img {
        position: absolute;
        width: 100%;
        height: 100%;
        background: center / var(--premium-c-s--img-w) var(--premium-c-s--img-h) no-repeat;
        filter: grayscale(1);
        transition: filter .3s;

        &_active, &:hover {
            filter: grayscale(0);
        }
    }

    &__slide-info {
        position: relative;
        @include fluid('margin-top', -27px, -12px);
    }

    &__slide-labels {
        position: absolute;
        @include fluid('top', 24px, 12px);
        @include fluid('left', 24px, 12px);
    }

    &__close {
        @include mobile {
            @include fluid('top', 32px);
        }
    }
}
</style>
